<template>
  <v-card
    class="usabilla-widget"
    elevation="0"
  >
    <v-card-text>
      <div
        :id="`widget-${widgetId}`"
        :ub-in-page="widgetId"
        :ub-in-page-environment="environmentVariable"
        :ub-in-page-order="orderReference"
      />
    </v-card-text>
  </v-card>
</template>
<script>
export default {
  name: 'UsabillaWidget',
  props: {
    widgetId: {
      type: String,
      required: true
    },
    orderReference: {
      type: String,
      required: true
    }
  },
  computed: {
    environmentVariable () {
      return process.env.VUE_APP_USABILLA_WIDGET_ENV_VAR
    }
  },
  mounted () {
    this.$emit('on-widget-mounted', this.widgetId)
  }
}
</script>
<style lang="scss" scoped>
.usabilla-widget {
  max-width: 650px;
  margin: 0 auto;
}
</style>
